import React from 'react';
import { injectIntl } from 'react-intl';
import dwgSVG from './static/icons/dwg.svg';
import excelSVG from './static/icons/excel.svg';
import jpgSVG from './static/icons/jpg.svg';
import otherVG from './static/icons/other.svg';
import pdfSVG from './static/icons/pdf.svg';
import pngSVG from './static/icons/png.svg';
import wordSVG from './static/icons/word.svg';

const DownloadIcon = ({ mimetype }) => {
  let wordMimeTypes = [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.oasis.opendocument.text',
  ];
  let excelMimeTypes = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
  ];

  let icon;
  let iconName;
  if (mimetype === 'application/pdf') {
    icon = pdfSVG;
    iconName = 'pdf';
  } else if (mimetype === 'image/jpeg') {
    icon = jpgSVG;
    iconName = 'jpg';
  } else if (mimetype === 'image/png') {
    icon = pngSVG;
    iconName = 'png';
  } else if (wordMimeTypes.includes(mimetype)) {
    icon = wordSVG;
    iconName = 'word';
  } else if (excelMimeTypes.includes(mimetype)) {
    icon = excelSVG;
    iconName = 'excel';
  } else if (mimetype === 'application/octet-stream') {
    icon = dwgSVG;
    iconName = 'dwg';
  } else {
    icon = otherVG;
    iconName = 'other';
  }

  return (
    <svg
      xmlns={icon.attributes && icon.attributes.xmlns}
      viewBox={icon.attributes && icon.attributes.viewBox}
      className={`icon icon-${iconName}`}
      dangerouslySetInnerHTML={{
        __html: `<title>${iconName}</title>${icon.content}`,
      }}
    />
  );
};

export default injectIntl(DownloadIcon);
